export const SET_OBJECT_ID = 'search/SET_OBJECT_ID' as const;

export const setSelectedObjectId = (payload: { objectId: string }) => ({
  type: SET_OBJECT_ID,
  payload,
});
